import Andy from "../static/images/sectionTalking/2023/Andy_color.jpg";
import Andy1 from "../static/images/sectionTalking/2023/Andy_pbw.png";
import Anita from "../static/images/sectionTalking/2023/Anita_color.jpg";
import Anita1 from "../static/images/sectionTalking/2023/Anita_pbw.png";
import Bryan from "../static/images/sectionTalking/2023/Bryan_color.jpg";
import Bryan1 from "../static/images/sectionTalking/2023/Bryan_pbw.png";
import Carol from "../static/images/sectionTalking/2023/Carol_color.jpg";
import Carol1 from "../static/images/sectionTalking/2023/Carol_pbw.png";
import Justin from "../static/images/sectionTalking/2023/Justin_color.jpg";
import Justin1 from "../static/images/sectionTalking/2023/Justin_pbw.png";
import Kate from "../static/images/sectionTalking/2023/Kate_color.jpg";
import Kate1 from "../static/images/sectionTalking/2023/Kate_pbw.png";
import Katherine from "../static/images/sectionTalking/2023/Katherine_color.jpg";
import Katherine1 from "../static/images/sectionTalking/2023/Katherine_pbw.png";
import Kimmy from "../static/images/sectionTalking/2023/Kimmy_color.jpg";
import Kimmy1 from "../static/images/sectionTalking/2023/Kimmy_pbw.png";
import Lina from "../static/images/sectionTalking/2023/Lina_color.jpg";
import Lina1 from "../static/images/sectionTalking/2023/Lina_pbw.png";
import Matthew from "../static/images/sectionTalking/2023/Matthew_color.jpg";
import Matthew1 from "../static/images/sectionTalking/2023/Matthew_pbw.png";
import Nine from "../static/images/sectionTalking/2023/Nine_color.jpg";
import Nine1 from "../static/images/sectionTalking/2023/Nine_pbw.png";
import Ning from "../static/images/sectionTalking/2023/Ning_color.jpg";
import Ning1 from "../static/images/sectionTalking/2023/Ning_pbw.png";
import Sharon from "../static/images/sectionTalking/2023/Sharon_color.jpg";
import Sharon1 from "../static/images/sectionTalking/2023/Sharon_pbw.png";
import Vid from "../static/images/sectionTalking/2023/Vid_color.jpg";
import Vid1 from "../static/images/sectionTalking/2023/Vid_pbw.png";
import Zoe from "../static/images/sectionTalking/2023/Zoe_color.jpg";
import Zoe1 from "../static/images/sectionTalking/2023/Zoe_pbw.png";

export default [
  {
    name: "Kimmy",
    position: "Accounting Intern",
    img: Kimmy1,
    photo: Kimmy,
    article: `
            <p>Hello 大家~我是 Accounting Intern, Kimmy.</p>

            <p>目前主要負責的工作是：客戶退款處理、開立發票、員工請款資料更新、建立銷貨訂單、文件用印與歸檔、整理傳票、印花稅整理。</p>

            <p>在新芽當會計實習生時，讓我學習到了非常多財務部門的工作！除了出納的工作外，還有文件用印、採購流程、盤點公司資產都是我之前從沒接觸過的領域。(想起初來乍到時根本分辨不出合約的差別、印花稅是何物><，但經由幾個月的努力以及部門同事的教導，現在很多工作都已經非常上手！)</p>

            <p>此外，公司每個月會開一次全公司的會議 (Sprouter’s Day) 及財務部門月會，從公司大會中可以聽到不同部門的進度報告、了解各部門目前處理什麼專案、開發甚麼軟體。在財務月會中，也會報告每個月財務工作。雖然我沒有開始實際報告事項，但能從老闆、財務長的討論中，聽到一些之前沒在課堂接觸過的事。每一季財務長也會準備主題課來讓大家更了解公司、財務及稅務方面需要注意的事項，受益良多。</p>

            <p>在新芽當小芽的日子中非常開心能認識各位很好的同事、參與公司大小會議！我認為身為一個財務人，最重要的是對於數字的敏感以及細心的態度！歡迎大家加入新芽家庭，從一顆小芽開始茁壯長成大樹！🌲</p>
        `,
  },
  {
    name: "Anita",
    position: "DevOps Intern",
    img: Anita1,
    photo: Anita,
    article: `
            <p>​作為一名 DevOps 實習生，我在這裡學到了很多關於開發和運營之間密切合作的知識。通過實際案例，我更深入地了解了自動化部署、容器化技術以及持續集成和持續交付的重要性。這次實習不僅增進了我的專業技能，也拓寬了我對整個開發過程的理解。</p>

            <p>我非常幸運擁有一群優秀且友好的同事。每個人都願意分享他們的經驗和知識，給予我無微不至的幫助。這樣的團隊，讓我更有勇氣也更有信心克服挑戰。同時，這也促使我主動學習，迎接更多技術上的挑戰。</p>

            <p>最令我欣慰的是，我的主管總是給予我足夠的空間去嘗試新的事物。不管是新的技術、新的專案，還是流程上的改進，只要我有想法，主管都會鼓勵我嘗試並給予支持。這樣的工作環境激發了我的創造力，也使我更有動力去挑戰自己。</p>

            <p>最後，提到遠端上班的經驗。遠端上班讓我更加靈活地安排工作時間，同時也提高了我的自律性和遠程協作的能力。這樣的工作模式不僅展現了公司對於員工的信任，也為我提供了一個更加舒適、有彈性的工作環境。</p>

            <p>總的來說，這段 DevOps 實習經歷是我職業生涯中的一個重要里程碑，讓我成長了不少。感謝公司提供這樣的機會，也感謝所有與我共事的夥伴們。我將這次的經驗視為一份寶貴的財富，將在未來的工作中繼續發揮所學，不斷進步。</p>
        `,
  },
  {
    name: "Justin",
    position: "Front-End Developer Intern",
    img: Justin1,
    photo: Justin,
    article: `
            <p>HI~ 大家好，我是新芽 SurveyCake 的前端實習生 Justin！</p>

            <p>在新芽實習也不知不覺半年了，這段期間我主要的負責的是蛋糕企業版的後台優化，平時也會參與一些蛋糕前端的開發及 bug 修復。在這邊所接觸到的專案規模和複雜度都是在 side project 中接觸不到的，也讓我從中學到了很多新技術和套件，對於 git 和 git flow 也有了更深的了解。</p>

            <p>另外，蛋糕是採取 scrum 開發，而實習生也會參加開發會議，使我能更加了解蛋糕這個產品，參與一個 feature 的完整開發流程。而且不論遇到什麼問題，超強的蛋糕大大們都會不厭其煩的協助，回答我的各種問題，真的非常感謝！</p>

            <p>在新芽大部分的時間都是可以遠距的，讓我能順利的兼顧實習和課業，而在進辦公室上班時，漂亮的辦公室、不時的活動及聚餐、及最 nice 的公司大大和實習生夥伴也讓實體工作變得很快樂。最後，如果你對於新芽以及前端有興趣，那就展現出對於前端的熱情，並投下手中的履歷吧！！！</p>
        `,
  },
  {
    name: "Bryan",
    position: "Quality Assurance Engineer Intern",
    img: Bryan1,
    photo: Bryan,
    article: `
            <p>Hi 大家好， 我是新芽 SurveyCake QA Engineer Intern 的實習生 Bryan 賴廷恩，也是第一屆 QA 實習生。</p>

            <p>我主要負責 SurveyCake  的 E2E 自動化測試專案，平常除了依照 issue 修復之外，也需要撰寫新的測試項目， 到蛋糕前端專案新增元素 data-qa 以便測試抓取後執行，偶爾也需要修改 gitlab CI 的 yaml 檔案。</p>

            <p>SaaS 產品的測試是以往 side project 和學校課程不易接觸到的領域，像 E2E 的測試框架 Nightwatch.js，瀏覽器 UI 監控的 BrowserStack，專案版本控制的 Git flow，及維護自動化的 gitlab CI、pipeline 等等，都是進公司碰到大型專案才會接觸到。QA 的日常除了上述技術工具之外，需要對細節的追求及耐心，從明白測項的測試邏輯，撰寫測項時思考如何還原使用者情境，分析 issue 錯誤原因並排除，這些都訓練我對 SaaS 功能的敏銳度，在有限的時間下最有效去 try & error，是非常寶貴的經驗。</p>

            <p>新芽是個很神奇的地方，可以無限遠距辦公 ( 我曾經三個月沒到過公司 )，組織文化也非常扁平溫馨，蛋糕前端及產品部的大大人都很好，除了工作上的交流及協助外也很願意分享生活，就像大學的學長姊一樣，最重要的是辦公室真的超級漂亮，所以我也超喜歡來公司，不定期還會舉辦一些有趣的活動，快一起成為 sprouter，在新芽展開酷酷的職場冒險吧 >< </p>
        `,
  },
  {
    name: "Carol",
    position: "Project Management Intern",
    img: Carol1,
    photo: Carol,
    article: `
            <p>Hello, This is Carol in Project Management!</p>

            <p>如果要用一句話形容我的心得，我想那肯定是「來新芽實習絕對是我做過最棒的決定！」回想當初投新芽的一大契機是因為看到 JD 寫到「充分享受在 Spotify 音樂與垃圾話穿插夾雜的團隊樂趣」但在新芽實習的好處遠不止如此。</p>

            <p>作為專案管理實習生，我的工作非常多元。從前期的功能規劃、Wireframe 繪製、需求訪談，到開發後的功能測試、撰寫操作手冊等，過程中也會時常需要進行跨部門溝通，以保持專案的持續推進。</p>

            <p>套用老闆 Alex 曾說過的一句話：「如果只做有把握的事情，你怎麼知道自己的能耐在哪裡」儘管有時會因為缺乏軟體知識而受挫，但在新芽實習的一大特色就是只要你敢問、正職都會很願意幫你解惑（而且跟正職相處就像跟朋友一樣）讓身為科技小白的我能擴大舒適圈，不斷累積更多知識經驗！</p>
            
            <p>所以如果你不會害怕挑戰、對專案管理、網路軟體產業有興趣，那就趕快加入新芽吧</p>
        `,
  },
  {
    name: "Katherine",
    position: "Project Management Intern",
    img: Katherine1,
    photo: Katherine,
    article: `
            <p>我是 PM intern Katherine ，作為 PM intern 可以參與到許多不同類型不同階段不同形式的專案， 協助正職 PM 處理各種任務，因為沒有資訊相關背景，一開始有點挫敗，但也會有許多不同方面的成長，像是如何開立 Spec、繪製 wireframe、排查問題、產品測試，過程中遇到任何的問題，不論是正職 PM 或是開發者大家都會有耐心回答你的，而且會說明的很詳細，讓我更清楚事情的脈絡。</p>

            <p>在實習的過程有任何的想法或是想要嘗試的方向，公司也是樂於接受的，並不會有太多的規矩而限縮發展，公司的氣氛和環境都是很讚的，也因為可以遠距辦公，讓工作更有彈性，我很感謝能夠有這個實習機會，讓我得以在新芽成長茁壯。</p>

            <p>總歸很推薦對於軟體業或是 PM 有興趣的人一起加入新芽，相信會是一趟很有收穫的旅程！</p>
        `,
  },
  {
    name: "Ning",
    position: "Project Management Intern",
    img: Ning1,
    photo: Ning,
    article: `
            <p>Hihi 大家好～我是 PM intern Ning！</p>

            <p>因為大學就讀資管系的關係，從那時開始我就一直對軟體 PM 很有憧憬，後來也很幸運進入新芽，開啟我的第一份實習！</p>

            <p>這段實習的過程帶給我幫助最大的就是 - 更了解 PM 的工作內容，雖然原來就有所了解，但我覺得實際接觸過以後，會發現有更多體悟跟細節，尤其作為專案端的 PM 實習生，會接觸到不同階段及不同產業的專案，這些經驗都讓我更了解專案每階段的重點以及如何安排時程等，同時透過參與客戶例會，也會更懂得身為 PM 應如何與客戶溝通，當然還有很多其他的工作內容，像是測試、撰寫 test case、製作客戶教學手冊、整理規格表等等，有機會的話也可以參與一些小項目的規劃，有些工作內容或許剛開始會覺得很瑣碎，但後來就會發現其實都是訓練邏輯思維的一環，以 test case 撰寫來舉例，除了要熟悉整個網站的運行方式外，還需要去思考如何劃分，才能列出完整包含所有狀況的測試項目，這些都幫助我學習及思考了很多，尤其如果又從中找到沒有人發現的 bug 問題，真的會蠻有成就感的～～</p>

            <p>最後！我真心覺得能夠在新芽開始我的第一份實習是一件超級幸運的事～不管是正職還是實習生同事，大家都人超好的～剛開始有很多笨問題的時候， Mentor 也都很仔細跟耐心地講解，最後還會鼓勵我，真的在這裡有很好的成長跟體驗，推薦對 PM 職位跟軟體業有興趣的大家來新芽探索，畢竟沒有什麼比直接在實作中學習更快的～</p>
        `,
  },
  {
    name: "Andy",
    position: "Project Management Intern",
    img: Andy1,
    photo: Andy,
    article: `
            <p>Hi 我是 PM intern Andy</p>

            <p>雖然我之前也有在其他公司擔任過軟體 PM intern，但到新芽實習後，才對於軟體開發的實務及流程有更全面的認識，作為專案部門的實習生，這段實習過程我總共接觸了四個不同產業的專案，讓我認識更多產業的需求、背景知識；</p>

            <p>PM intern 的工作內容相當全面，包含規劃測試方式、撰寫測試報告、撰寫操作手冊以及實際參與客戶例會並撰寫會議紀錄等等。</p>

            <p>在新芽的專案部門，正職 PM 都會提供許多機會及資源讓實習生能實際參與專案，並發揮個人影響力，在專案功能上線的時候也能感受到同為開發團隊的成就感；除此之外，公司的組織文化也相當扁平，團隊氛圍也相當良好且鼓勵學習，我認為很適合學生、新鮮人來這邊實習，除日常的工作外，也參與公司各種大大小小的活動、工作坊，探索並持續深掘軟體開發的流程及專案管理的方式。</p>
        `,
  },
  {
    name: "Lina",
    position: "Account Management Intern",
    img: Lina1,
    photo: Lina,
    article: `
            <p>Hello, 我是 AM Intern Lina！</p>

            <p>還記得剛成為菜鳥實習生時，第一次做提案挫折感滿滿，不過現今回顧起來只覺得收穫滿滿！AM 的主要工作為釐清客戶需求及痛點，製作客製化、User Friendly 的提案與專案規劃。在實習期間，有很多跟著 Mentor 一起去拜訪客戶及開會的機會，可以接觸各行各業的客戶，了解不同產業的特性。</p>

            <p>除了專案以外，AM Intern 還有接觸我們的 AI 產品 — Bizbase 的機會，我很幸運可以跟隨 AI 浪潮的前沿，見證數位轉型的過程。更令人興奮的是參加一些大型展覽，如 2023 Meet Taipei，可以站到第一線親自與顧客分享我們的產品與服務，是難能可貴的經驗！</p>

            <p>而新芽最大的特色，大概是自由且活潑的公司文化，與一群超 nice 的公司同事們。如果有任何不了解的，Mentor 都很樂意為你解答，也會與實習生一起 Brainstorming，激發出新潮的解決方案。</p>

            <p>如果你渴望擴展自己的視野，勇於與人溝通，歡迎你成為 Sprouter，在新芽慢慢發芽！</p>
        `,
  },
  {
    name: "Vid",
    position: "Marketing Intern",
    img: Vid1,
    photo: Vid,
    article: `
            <p>Hey there! I’m Vid, SurveyCake’s Marketing Intern from Indonesia.</p>

            <p>Time sure has flown by! I can't believe it's been six months since I started my internship at 25sprout (SurveyCake).</p>

            <p>Jumping into marketing as a Math student was definitely a new challenge for me. As a Marketing Intern, my main focus has been on growing and managing the Indonesian market. It's been tough at times, but with the help of amazing and supportive mentors and colleagues, I've been able to tackle the challenges head-on.</p>

            <p>It has been a fruitful and valuable journey for me. I had a chance to understand more about how a company works, how to work together as a team, improving my communication skills, learning more about the marketing world, and having discussions and brainstorming new marketing ideas with my teammates.</p>

            <p>I must say, 25sprout has a positive and supportive working environment. For me, adapting to new situations as a foreigner was kind of hard. However, with very welcoming colleagues, I don’t really feel like an “outsider” here. A big shout-out to 25sprout for being such an awesome company! I feel really blessed to have had my first internship experience here. Finally, for those of you international students out there, you are very welcome to become the next sprouters and let’s grow together! 🌱</p>
        `,
  },
  {
    name: "Nine",
    position: "Marketing Intern",
    img: Nine1,
    photo: Nine,
    article: `
            <p>Hello Everyone! I’m Nine, a Bangkok native currently interning in a marketing position. My main task is to observe and provide insights into the Thailand market, utilizing my experience and skills to contribute effectively.</p>

            <p>I would like to express that interning at 25sprout has been a fantastic choice! The company not only met but exceeded my expectations for the working environment of a Taiwanese company. The workplace is innovative, with a cool working system, and it’s full of youthful energy, significantly broadening my horizons. What I like the most is how they make every task as simple as a piece of cake by seamlessly integrating technology and AI into our workflow. It’s truly impressive!</p>

            <p>Plus, as a foreigner in a different city and culture, I initially thought adapting would be tough. However, from day 1 at 25sprout, they’ve treated everyone equally and offered help whenever I faced difficulties, for which I am very grateful.</p>

            <p>To those who are still undecided, I strongly encourage you to apply for the internship program at 25sprout. Trust me! every day here will bring you a unique and rewarding experience.</p>
        `,
  },
  {
    name: "Zoe",
    position: "UI/UX Design Intern",
    img: Zoe1,
    photo: Zoe,
    article: `
            <p>一開始，我是被新芽的企業文化所吸引，加上過去有過幾次跟新芽人共事的愉快經驗，讓我開始對這家公司產生好感跟興趣。因為我是從文字編輯轉職到 UI/UX 領域的設計師，很開心新芽的實習生機會沒有任何身份或年齡的限制，讓我有機會加入新芽大家庭，展開這趟有趣的旅程！</p>

            <p>我在新芽主要負責整理設計系統，以及規劃專案的部分流程設計和介面設計。雖然我曾在產品新創擔任主要設計師，但因為工作性質的不同，在新芽實習的這段期間，我仍然學習到很多；除了見識到優秀設計師應該具備的態度跟模樣之外，也在與不同設計師合作時提升了協作能力。</p>

            <p>一直以來，我都很嚮往能夠有設計同事一起交流想法，新芽完全滿足了我這個小願望～ XD 每當我提出設計上的想法或遇到困難時，團隊夥伴總是友善且樂意給予實質的改善建議。</p>

            <p>我很喜歡新芽的工作氛圍，即便是全遠端工作型態，但是大家仍然會保有默契，定期約在公司工作培養團隊感情，這是我覺得很讚的地方～如果你正在找一個注重美感、視覺表現且氛圍和諧的工作環境，我想新芽會是一個很棒的選擇！</p>
        `,
  },
  {
    name: "Kate",
    position: "Business Development Intern",
    img: Kate1,
    photo: Kate,
    article: `
            <p>Hello~ 我是 Business Development 的 Intern - Kate！</p>

            <p>還記得剛加入新芽時，菜到不行的我彷彿劉姥姥誤闖科技軟體大觀園，對於一切事務都還在努力適應與熟悉。但在主管和夥伴們細心 + 很有耐心教導下，無論是業務技巧、跨部門溝通、乃至於撰寫各類文件的能力，都有大幅的成長與進步。現在（應該）也能驕傲的說出，問卷大小事都是 a piece of cake !</p>

            <p>Intern 需要全力協助 BD 完成提案、企劃以及客戶管理等相關事務。其中包含了拜訪前的需求釐清，拜訪中的會議紀錄、即時支援查找相關文件、確認導入問卷系統的流程，拜訪後撰寫感謝信、試用裝機、進度追蹤、製作報價單、開發票、交接文件....。總結來說，實習的過程會讓妳更通盤了解 BD 大小事，讓每筆問卷的填答都能為企業創造最大價值！（參與客戶會議是實習生的一大福音，一定要好好把握）</p>

            <p>此外，定期清整數據、製作月會簡報、成功案例的過程中，會對於各渠道的進線客戶有更深層的了解。聆聽公司其他部門報告的過程中，也會對 SurveyCake 乃至於 25sprout 旗下的所有產品迭代有更全面的認識。</p>

            <p>最後，可以經常遠距上班 （默默變成跑咖王）、有一起亂講垃圾話的同事、漂亮的高樓風景辦公室、每季的免費電影、年度的 Sprouters' Outing...，都是私心覺得幸福感滿滿的公司福利。</p>

            <p>如果你喜歡與人溝通，且對參與新創公司的成長充滿熱情，歡迎一起加入新芽的大家庭！（有任何希望私下請教的問題，也歡迎通過 FB : Kate Cheng 聯絡我）</p>
        `,
  },
  {
    name: "Sharon",
    position: "Customer Success Intern",
    img: Sharon1,
    photo: Sharon,
    article: `
            <p>Hello～我是 Customer Success 的 Intern Sharon！</p>

            <p>在新芽待了快一年的時間，只能說我完全不會後悔當初的決定～真的很開心可以加入新芽這個大家庭！</p>

            <p>儘管一開始的我對於 Customer Success 還不是那麼熟悉，不過也很幸運遇到了我的主管、夥伴們，大家都很願意提供協助、不吝嗇分享，也很願意讓我嘗試各種事情，才讓我一步一步成長到現在！</p>

            <p>我在新芽主要是負責協助 SurveyCake 用戶解決使用問題、蒐集用戶對於產品的各種反饋，幫助用戶能在 SurveyCake 獲得很好的使用體驗。</p>

            <p>在 CS 例行會議中，我們不僅會討論工作事項，也會分享一些平時不太接觸到的小知識，讓大家在工作之餘，有機會在不同領域互相交流，這些分享或許也能在工作中獲得小小的幫助～</p>

            <p>很謝謝新芽讓我有機會和團隊夥伴們一起學習、交流，在這邊真的可以盡情發揮自己想做的！如果你對 CS 有興趣，且想感受新芽歡樂的文化，那就一起來加入我們吧！期待你能在這裡和我們一起創造更多有趣的故事：）</p>
        `,
  },
  {
    name: "Matthew",
    position: "Product Management Intern",
    img: Matthew1,
    photo: Matthew,
    article: `
            <p>嘿嘿，大家好啊！我是 BackStage 的 Product Management Intern 馬修，在這裡滿開心能和各位分享我在新芽的工作經驗和心得。</p>

            <p>我的工作內容圍繞著我所負責的產品 Bizbase 和 BackStage ，工作日常都會使用些工具，進行產品測試紀錄，撰寫操作手冊與 changelog，定期進行產品的時間規劃和發布產品上版 issue。另外，每週二和四，我都會參與開發團隊的例會，從中學習正職的 PM、設計師以及前後端開發人員是如何進行產品開發的討論，同時協助整理會議記錄等等。</p>

            <p>上述所描述的工作，能跟大家告解自己不是一進來就立即上手的。自己需要花時間去學習和吸收資訊，偶爾也會迷迷糊糊，犯錯事情。但，和我搭配的正職 PM 與新芽夥伴們一起合作，大家都非常樂於幫助，這點讓我很感激。此外，正職 PM 也滿願意給我彈性的空間去發揮和嘗試。每天進步一點，這些積累的經驗無形地建立起基礎。這樣學習與成長的步調，對我來說都是有價值與成就感的。</p>

            <p>實習到現在，正因為這裡友好的工作氛圍和充滿挑戰性的工作內容，讓我成長了許多。在這裡的實踐經驗，對我未來的職涯有了更清晰的規劃，繼續往不遠處的路邁進 ～</p>

            <p>最後，若對於 Product Management Intern 有興趣的大家，推薦你們選擇新芽投遞履歷，一同加入我們的行列！</p>
        `,
  },

];



// WEBPACK FOOTER //
// ./src/models/Sprouters2023.js